(function () {
  'use strict';
  const visiblePhotos = photos => Array.from(photos).filter(photo => !photo.hidden && !!photo.getAttribute('src'));
  const selectionShouldScroll = input => !!input && input.tagName === 'INPUT' && input.type === 'radio' && input.checked && ['color','finish'].includes(input.name);
  const scrollTargetTop = (rect, current, headerHeight) => Math.max(0, current + rect.top - headerHeight - 12);
  const selectedIndex = (offsets, position) => offsets.reduce((best,offset,index) => Math.abs(offset-position) < Math.abs(offsets[best]-position) ? index : best,0);
  if (typeof module !== 'undefined' && module.exports) { module.exports = {visiblePhotos,selectionShouldScroll,scrollTargetTop,selectedIndex}; return; }
  function boot() {
    const main = document.querySelector('[id^="MainProduct-"]');
    const panel = main?.querySelector('.lc-visual-panel');
    const gallery = main?.querySelector('.lc-alternate-gallery');
    if (!main || !panel || !gallery || main.dataset.directReady) return;
    main.dataset.directReady = 'true';
    main.classList.add('ls-direct-product');
    document.documentElement.classList.add('ls-direct-active');
    const english = document.documentElement.lang.startsWith('en');
    const mobile = matchMedia('(max-width:749px)');
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const track = document.createElement('div');
    track.className = 'ls-direct-track';
    const photos = Array.from(gallery.children).filter(node => node.tagName === 'IMG');
    if (!photos.length) return;
    photos[0].before(track);
    photos.forEach(photo => track.append(photo));
    const controls = document.createElement('div');
    controls.className = 'ls-direct-gallery-controls';
    controls.setAttribute('role','group');
    controls.setAttribute('aria-label',english ? 'Product views' : 'Productfoto’s');
    track.after(controls);
    let currentPhotos = [];
    const offsets = () => currentPhotos.map(photo => photo.offsetLeft-currentPhotos[0].offsetLeft);
    const updateIndicator = () => {
      if (!mobile.matches) return;
      const index = selectedIndex(offsets(),track.scrollLeft);
      controls.querySelectorAll('button').forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
    };
    function refresh() {
      const next = visiblePhotos(photos);
      if (next.length !== currentPhotos.length || next.some((photo,i) => photo !== currentPhotos[i])) {
        currentPhotos = next;
        controls.replaceChildren();
        next.forEach((photo,index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label',english ? 'Photo '+(index+1)+' of '+next.length : 'Foto '+(index+1)+' van '+next.length);
          button.setAttribute('aria-pressed',String(index === 0));
          button.addEventListener('click',() => track.scrollTo({left:offsets()[index],behavior:reduce() ? 'auto' : 'smooth'}));
          controls.append(button);
        });

      }
      controls.hidden = next.length < 2;
      updateIndicator();
      const note = gallery.querySelector('.ls-flow-photo-note');
      const finishes = panel.querySelector('fieldset:has(input[name="finish"])');
      if (note && finishes) finishes.append(note);
    }
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; refresh(); });
    });
    observer.observe(track,{subtree:true,attributes:true,attributeFilter:['hidden','src']});
    observer.observe(gallery,{childList:true});
    track.addEventListener('scroll',updateIndicator,{passive:true});
    mobile.addEventListener('change',() => { track.scrollLeft = 0; refresh(); });
    panel.addEventListener('change',event => {
      if (!selectionShouldScroll(event.target)) return;
      requestAnimationFrame(() => {
        refresh();
        if (mobile.matches) track.scrollLeft = 0;
        const header = document.querySelector('.section-header');
        const target = !gallery.hidden ? gallery : main.querySelector('media-gallery:not([hidden])');
        if (!target) return;
        window.scrollTo({top:scrollTargetTop(target.getBoundingClientRect(),window.scrollY,header?.getBoundingClientRect().height || 0),behavior:reduce() ? 'auto' : 'smooth'});
      });
    });
    panel.querySelectorAll('input[name="color"]').forEach(input => {
      if (!['Sand','Ice Blue'].includes(input.value)) return;
      const label = input.closest('.lc-option');
      if (!label || label.querySelector('.ls-direct-favourite')) return;
      const badge = document.createElement('span');
      badge.className = 'ls-direct-favourite';
      badge.textContent = 'Favorite pick';
      label.append(badge);
    });
    const finishLegend = panel.querySelector('fieldset:has(input[name="finish"]) legend');
    if (finishLegend) {
      const hint = document.createElement('span');
      hint.className = 'ls-direct-finish-hint';
      hint.textContent = english ? 'Swipe to compare finishes' : 'Swipe om afwerkingen te vergelijken';
      finishLegend.append(hint);
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
